import React from 'react'
import { UserContextProvider } from '../context/UserContext'
import Layout from '../components/Layout'
import StrapiTable from '../sections/StrapiTable'
import { PERTANDINGAN_TABLE_HEADERS } from '../constants/table-header'
import { useNavigate } from 'react-router-dom'
import { deleteMatches, getAllMatches } from '../services/match.service'
import { toast } from 'react-toastify'

const ListPertandingan = () => {
  const navigate = useNavigate()
  const onDelete = async (id) => {
    try {
      await deleteMatches({ id })
      navigate(0)
    } catch (error) {
      toast.error(error?.response?.data?.error?.message ?? 'Error')
    }
  }

  return (
    <UserContextProvider>
      <Layout activeNav="Pertandingan">
        <div className="p-3 lg:pl-0">
          <StrapiTable
            title="Pertandingan"
            headers={PERTANDINGAN_TABLE_HEADERS}
            // createLink="/konten/pertandingan/create"
            fetchFunction={getAllMatches}
            onDelete={(id) => onDelete(id)}
            onEdit={(id) => navigate(`/konten/pertandingan/edit/${id}`)}
          />
        </div>
      </Layout>
    </UserContextProvider>
  )
}

export default ListPertandingan
